export const groupedAttributes: any = {
  'engineBase': {
    title: 'Engine', // title in column builder
    groupTitle: 'ENGINE', // title dispayed inside search results table
    option: 'engineBase',
    columnName: 'engineBase',
    attributes: [
      'engineLiter',
      'engineCC',
      'engineCID',
      'engineBlockType',
      'engineCylinder',
      'engineBoreIN',
      'engineBoreMT',
      'engineStrokeIN',
      'engineStrokeMT',
    ],
  },
};
